// Auth routes
export const REGISTER = "register";
export const SEND_OTP = "send-otp";
export const LOGIN = "signin";
export const REQUEST_PASSWORD_RESET = "request-password-reset";
export const RESET_PASSWORD = "password-reset";
export const CHANGE_PASSWORD = "change-password";
export const MAILING_LIST = "mailing-list";
export const CONTACT_OUR_SUPPORT = "contact-our-support";
export const DISPUTE_TRANSACTION = "dispute-transaction";
export const CREATE_TRANSACTION = "create-transaction";
export const VERIFY_TRANSACTION = "verify-transaction";
export const ADD_LOCATION = "verify-transaction";
export const VERIFY_TRANSACTION_DETAILS = "verify-transaction-details";
export const UPDATE_TRANSACTION_STATUS = "update-transaction-status";
export const UPDATE_USER_PROFILE = "update-user-profile";
export const UPDATE_USER_BANK_DETAILS = "update-user-account-details";
export const UPDATE_USER_CONTACT_DETAILS = "update-user-contact-details";
export const UPDATE_USER_KYC_DETAILS = "update-user-kyc-details";

export const GET_USER_BY_ID = "getUserById";

export const USER_TOKEN = "USER_TOKEN";
export const USER_ID = "USER_ID";
